// Página de listagem de eventos
import EventsGrid from "@/components/events-grid";

export default function EventsListPage() {
    return (
        <div className="min-h-screen bg-gray-50">
            {/* Header */}
            <section className="py-6 bg-gradient-to-r from-primary to-teal-600 text-white">
                <div className="container mx-auto px-4 text-center">
                    <h1 className="text-2xl font-bold mb-2">Eventos Esportivos</h1>
                    <p className="text-sm text-white/90 max-w-xl mx-auto">
                        Descubra eventos incríveis e reviva seus melhores momentos através das fotos
                    </p>
                </div>
            </section>

            {/* Events Grid */}
            <EventsGrid />
        </div>
    );
}